<section class="cfd-tile">
  <div class="cfd-tile__body">
    <header class="cfd-tile__header">
      <h4 class="cfd-tile__title">
        <a [routerLink]="cfdListLink()">CFDs</a>
      </h4>
    </header>

    @if (isComplete()) {
      <a
        class="cfd-tile__complete"
        [routerLink]="cfdListLink()"
        matTooltip="Every RPO is uploaded or marked not needed">
        <mat-icon>check</mat-icon>
      </a>
    } @else if (counts(); as rows) {
      @if (totalRpos()) {
        <ul class="cfd-tile__counts">
          @for (row of rows; track row.bucket) {
            <li class="cfd-tile__count" [class.cfd-tile__count--zero]="!row.count">
              <a
                [routerLink]="cfdListLink()"
                [queryParams]="{ status: row.bucket }"
                [matTooltip]="'View ' + row.title + ' RPOs'">
                <span class="cfd-tile__count-label">{{ row.label }}</span>
                <span class="cfd-tile__count-value">{{ row.count }}</span>
              </a>
            </li>
          }
        </ul>
      } @else {
        <p class="cfd-tile__empty">No RPOs on this vehicle yet.</p>
      }
    } @else {
      <p class="cfd-tile__empty">Loading counts…</p>
    }
  </div>

  <div class="cfd-tile__actions">
    <a [routerLink]="modelTrimLinksLink()">
      <span>Link Model Trim</span>
      <mat-icon>chevron_right</mat-icon>
    </a>
    <button type="button" (click)="onCopyCfds()">
      <span>Copy Vehicle CFDs</span>
      <mat-icon>chevron_right</mat-icon>
    </button>
    <a routerLink="/data-exports/cfd-vehicle-reports" [queryParams]="reportQueryParams()">
      <span>View Report</span>
      <mat-icon>chevron_right</mat-icon>
    </a>
  </div>
</section>
